export default __webpack_public_path__ + "static/Creative_Buzz-00e20b62b6ecf0a8803ec3bb7ea0a41e.png";